import HttpService from "../util/HttpService";
import {PageStep} from "../enums/PageStep";
import ClientHttpService from "../util/ClientHttpService";
import ParamEncrypt from "../util/ParamEncrypt";

const CONTEXT_PATH = "/cwm/api/v2";
const SERVICE_PATH = "/document-upload-service/";

const DOCUMENT_SERVICE_PATH = "/cwm-document/api/v2";
const SERVICE_PATH_GATEWAY = "/document-service/";

class DocumentService {

    uploadDocument = (data: FormData) => {
        return HttpService.postWithConfig(CONTEXT_PATH.concat(SERVICE_PATH).concat("upload"), data, {
            headers: {

                'Accept': '*',
                'Content-Type': 'application/form-data; charset=UTF-8;x-www-form-urlencoded'
            }
        });
    }
    uploadManuallyCaptureDocument = (data: FormData) => {
        return HttpService.postWithConfig(CONTEXT_PATH.concat(SERVICE_PATH).concat("upload-captured-image"), data, {
            headers: {

                'Accept': '*',
                'Content-Type': 'application/form-data; charset=UTF-8;x-www-form-urlencoded'
            }
        });
    }

    getUploadDocumentListByType = (jobNo: number, identityDocumentTypeCodeList: string[]) => {
        return HttpService.post(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("list-by-type-list"), ParamEncrypt.encryptObject({
            jobNo: jobNo,
            identityDocumentTypeCodeList: identityDocumentTypeCodeList
        }));
    }
    getUploadDocumentListByTypeAndUploadedDocId = (jobNo: number, uploadedDocId: number, identityDocumentTypeCodeList: string[]) => {
        return HttpService.post(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("list-by-type-list-by-docId"), ParamEncrypt.encryptObject({
            jobNo: jobNo,
            identityDocumentTypeCodeList: identityDocumentTypeCodeList,
            uploadDocumentDetailId: uploadedDocId
        }));
    }
    getCapturedDocumentListByType = (jobNo: number, identityDocumentTypeCodeList: string[]) => {
        return HttpService.post(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("captured-list-by-type-list"), ParamEncrypt.encryptObject({
            jobNo: jobNo,
            identityDocumentTypeCodeList: identityDocumentTypeCodeList
        }));
    }
    fetchDocuments = (documentNames: string[]) => {

        return HttpService.post(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("list-agreements"), ParamEncrypt.encryptObject({
            fileCategory: documentNames
        }));
    }

    fetchAgreements = (documentNames: string[]) => {

        return ClientHttpService.post(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("list-agreements-before-login"), ParamEncrypt.encryptObjectWithEnvKey({
            fileCategory: documentNames
        }));
    }

    deleteDocument = (documentId: string, customerId: string, nextStep: PageStep) => {
        return HttpService.deleteOne(CONTEXT_PATH.concat(SERVICE_PATH).concat("delete-upload-document-detail/").concat(ParamEncrypt.encryptData(documentId)).concat("/").concat(ParamEncrypt.encryptData(customerId)).concat("/") + ParamEncrypt.encryptData(String(nextStep)));
    }

    deleteDocumentById = (documentId: string) => {
        return HttpService.deleteOne(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("delete-upload-document-detail/").concat(ParamEncrypt.encryptData(documentId)));
    }

    documentCaptureFailedFixing = (jobNumber: number, documentTypeCode: string) => {
        return HttpService.deleteOne(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("capture-failed/").concat(ParamEncrypt.encryptData(String(jobNumber))+"/").concat(ParamEncrypt.encryptData(documentTypeCode)));
    }
    viewOriginalDocument = (documentId: string) => {
        return HttpService.get(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("view-original-document/").concat(ParamEncrypt.encryptData(documentId)));
    }


    //video screen
    // getUploadDocumentList = (jobNo:string,identityDocumentTypeCode:string) => {
    //     return HttpService.get(`/cwm-document/api/v1/document-service/list?jobNo=${jobNo}&identityDocumentTypeCode=${identityDocumentTypeCode}`)
    // }

    getCapturedDocumentTypeList = (capturedDocument: boolean, identityDocumentTypeCode: string) => {
        // return HttpService.get(`/cwm-document/api/v1/document-service/document-type/${capturedDocument}/${identityDocumentTypeCode}`)
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("document-type/").concat(capturedDocument + "/").concat(ParamEncrypt.encryptData(identityDocumentTypeCode)));
    }
    getDocumentTypeList = (capturedDocument: boolean, identityDocumentTypeCode: string) => {
        return HttpService.get(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("document-type/").concat(capturedDocument + "/").concat(ParamEncrypt.encryptData(identityDocumentTypeCode)));
    }
    getDocumentTypeListByJobNo = (capturedDocument: boolean, identityDocumentTypeCode: string, jobNo: number) => {
        return HttpService.get(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("document-type/")
            .concat(capturedDocument + "/").concat(ParamEncrypt.encryptData(identityDocumentTypeCode) + "/").concat(ParamEncrypt.encryptData(String(jobNo))));
    }
    getDocumentBlob = (documentId: number) => {
        // return HttpService.getBlob("/cwm-document/api/v1/document-service/view-document/" + documentId)
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("view-document/" + ParamEncrypt.encryptData(String(documentId))));
    }

    getThumbDocumentBlob = (documentId: number) => {
        return HttpService.getBlob("/cwm-document/api/v2/document-service/view-thumb-document/" + ParamEncrypt.encryptData(String(documentId)))
    }


    updateApproveDocumentStatus = (data: any) => {
        // return HttpService.put("/document/api/v1/document-service/update-document-status/approve", data);
        return HttpService.put(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("update-document-status"), ParamEncrypt.encryptObject(data));
    }

    updateRejectDocumentStatus = (data: any) => {
        return HttpService.put("/document/api/v2/document-service/update-document-status/reject", ParamEncrypt.encryptObject(data));
    }

    // uploadDocument = (formData: any, setProgress?: any) => {
    //     return HttpService.postWithConfig("/document/api/v1/document-service/upload"
    //         , formData
    //         , {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data'
    //             }, onUploadProgress: data => {
    //             },
    //         });
    // }

    // deleteDocument = (uploadDocumentDetailId: string) => {
    //     return HttpService.deleteOne("/document/api/v1/document-service/upload/" + uploadDocumentDetailId)
    // }


    getUploadDocumentDetail = (uploadDocumentDetailId: string) => {
        return HttpService.get("/document/api/v2/document-service/upload-document/" + ParamEncrypt.encryptData(uploadDocumentDetailId))
    }

    getUploadDocumentDetailByUploadDocumentDetailIdList = (uploadDocumentDetailIdList: Array<number>) => {
        return HttpService.get("/document/api/v2/document-service/upload-document/view/" + ParamEncrypt.encryptData(uploadDocumentDetailIdList))
    }

    checkPendingDocuments = (jobNo: string) => {
        return HttpService.get("/common/api/v2/document-service/document-type/isPending/" + ParamEncrypt.encryptData(jobNo));
    }
    viewDocument = (uploadDocumentDetailId: number) => {
        return HttpService.getBlob(DOCUMENT_SERVICE_PATH.concat(SERVICE_PATH_GATEWAY).concat("view-document/").concat(ParamEncrypt.encryptData(String(uploadDocumentDetailId))));
    }

    getQRCode = (quotationNo: string) => {
        return HttpService.getBlob("/document/api/v2/document-service/view-qr-quotation-letter/" + ParamEncrypt.encryptData(quotationNo))
    }

}

const documentService = new DocumentService();
export default documentService;
